import * as tempusdominus from '@eonasdan/tempus-dominus';

$.fn.datetimepicker = function(options) {
   return new tempusdominus.TempusDominus(this[0], options);
}